/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useEffect, useRef, useState } from 'react';
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { FaStar } from 'react-icons/fa';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { RiVerifiedBadgeFill } from "react-icons/ri";
import Slider from "react-slick";
import axios from 'axios';
import { MyContext } from '../../Context/MyProvider';
import { showToast } from '../../showTost';
import briefcaseicon from "../../assets/Icon/briefcase.svg";
import { useTranslation } from 'react-i18next';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Loading from '../Loading';
import secureLocalStorage from "react-secure-storage";
import ImageLoad from '../ImageLoad';
const CustomPrevArrow = ({ onClick }) => (
    <div
        onClick={onClick}
        className="bg-[#4038FF] p-[3px] rounded-[50px] absolute z-10 right-[40px] -top-[32px] transform -translate-y-1/2 cursor-pointer"
    >
        <MdChevronLeft color="#fff" size={20} />
    </div>
);

const CustomNextArrow = ({ onClick }) => (
    <div
        onClick={onClick}
        className="bg-[#4038FF] p-[3px] rounded-[50px] absolute z-10 right-[0px] -top-[32px] transform -translate-y-1/2 cursor-pointer"
    >
        <MdChevronRight color="#fff" size={20} />
    </div>
);

const DocProfile = () => {

    const { t } = useTranslation();

    const { ApiBaseUrl, ImgBaseUrl, setIsLoginShow } = useContext(MyContext);

    const site_currency = secureLocalStorage.getItem("currency");
    const currency = site_currency ? site_currency : "$";

    const [loading, setLoading] = useState(true);
    const [expandedIndex, setExpandedIndex] = useState("");
    const [faqList, setFaqList] = useState([]);
    const [isShow, setIsShow] = useState(false);
    const [selectBtn1, setSelectBtn1] = useState(0);
    const [serviceid, setServiceId] = useState();
    const [dateList, setDateList] = useState([]);
    const [dateSelect, setDateSelect] = useState();
    const [timeLiat, setTimeList] = useState();
    const [timeSelect, setTimeSelect] = useState("");
    const [doctorData, setDoctorData] = useState();
    const [reviews, setReviews] = useState([]);
    const [awards, setAwards] = useState([]);
    const [photos, setPhotos] = useState([]);
    const [photosIndex, setphotosIndex] = useState("");
    const [showLightBox, setShowLightBox] = useState(false);
    const [service, setService] = useState([]);
    const [showType, setShowType] = useState();
    const [hospitalList, setHospitalList] = useState([]);
    const [selectHospitalId, setSelectHospitalId] = useState();
    const [timeLoading, setTimeLoading] = useState(false);
    const [dateType, setDateType] = useState();
    const [showTypePrice, setShowTypePrice] = useState("");
    const [isFav, setIsFav] = useState("");

    const { department_id, id } = useParams();

    const Data = sessionStorage.getItem("Docprofile");
    if (Data) {
        var { title, path, pagename } = JSON.parse(Data);
    }

    const navigate = useNavigate();

    const handleChange = (index) => {
        const Index = expandedIndex === index ? "" : index;
        setExpandedIndex(Index);
    };

    const settingsday = {
        arrows: false,
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            { breakpoint: 995, settings: { slidesToShow: 4, slidesToScroll: 1 } },
            { breakpoint: 900, settings: { slidesToShow: 3, slidesToScroll: 1 } },
            { breakpoint: 530, settings: { slidesToShow: 2, slidesToScroll: 1 } },
        ],
    };

    const settingstime = {
        arrows: true,
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 6,
        slidesToScroll: 1,
        nextArrow: <CustomNextArrow />,
        prevArrow: <CustomPrevArrow />,
        responsive: [
            { breakpoint: 995, settings: { slidesToShow: 6, slidesToScroll: 1 } },
            { breakpoint: 900, settings: { slidesToShow: 5, slidesToScroll: 1 } },
            { breakpoint: 580, settings: { slidesToShow: 4, slidesToScroll: 1 } },
            { breakpoint: 430, settings: { slidesToShow: 4, slidesToScroll: 1 } },
            { breakpoint: 380, settings: { slidesToShow: 3, slidesToScroll: 1 } },
        ],
    };

    const ServiceSetting = {
        arrows: true,
        dots: false,
        infinite: false,
        speed: 1000,
        slidesToShow: 3,
        slidesToScroll: 1,
        nextArrow: <CustomNextArrow />,
        prevArrow: <CustomPrevArrow />,
        responsive: [
            { breakpoint: 1200, settings: { slidesToShow: 2, slidesToScroll: 1 } },
            { breakpoint: 1024, settings: { slidesToShow: 2, slidesToScroll: 1 } },
            { breakpoint: 770, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        ],
    };

    useEffect(() => {
        fetchData();
    }, [Data]);

    useEffect(() => {
        loading
            ? document.body.style.overflow = "hidden"
            : document.body.style.overflow = "auto"
    }, [loading]);

    const fetchData = () => {
        const Userid = secureLocalStorage.getItem("Userid") || "0";
        setLoading(true);

        if (Userid) {

            axios.post(`${ApiBaseUrl}/customer/doctor_detail`, { department_id: department_id, d_id: id, id: Userid })
                .then((res) => {
                    const { ResponseCode, doctor, review_data, award_data, gallery_list, faq_data, alldate, ndatelist, hospital_list, dep_sub_ser_list } = res.data;
                    if (ResponseCode === 200) {
                        setLoading(false);
                        setDoctorData(doctor);
                        setReviews(review_data);
                        setAwards(award_data);
                        setFaqList(faq_data);
                        setDateList(alldate);
                        setDateSelect(alldate[0].date);
                        setTimeList(ndatelist);
                        setHospitalList(hospital_list);
                        setIsFav(doctor.tot_favorite);
                        setService(dep_sub_ser_list);
                        setServiceId(dep_sub_ser_list[0]);
                        setShowType(dep_sub_ser_list[0].show_type);
                        const index = dep_sub_ser_list[0].show_type === "2" ? 1 : 0;
                        setSelectBtn1(index);
                        const Photos = gallery_list;
                        const newPhotos = Photos.map(photo => ({ src: ImgBaseUrl + photo.image }));
                        setPhotos(newPhotos);
                    } else {
                        navigate("/");
                    }
                })
                .catch((error) => {
                    console.error(error);
                })
        }
    }

    useEffect(() => {
        setTimeSelect("");
        setShowTypePrice("");
        HandleDateSelect(dateSelect);
    }, [serviceid]);

    useEffect(() => {
        if (!timeSelect) return;
        const selectedService = service.find(item => item.id === serviceid.id);
        const ShowTypePrice = selectedService
            ? (selectBtn1 === 0 ? selectedService.client_visit_price : selectedService.video_consult_price)
            : null;
        setShowTypePrice(ShowTypePrice);
    }, [selectBtn1]);

    const HandleTimeSelect = (item, dtype) => {
        if (item.o === 0) {
            showToast({ title: t("You cannot book this time"), id: "error" });
        } else if (item.o === 2) {
            showToast({ title: t("This time is already book"), id: "error" });
        } else {
            if (timeSelect === item.t) {
                setTimeSelect("");
                setShowTypePrice("");
            } else {
                setTimeSelect(item.t);
                setSelectHospitalId(item.hid);
                setDateType(dtype);
                const selectedService = service.find(item => item.id === serviceid.id);
                const ShowTypePrice = selectedService
                    ? (selectBtn1 === 0 ? selectedService.client_visit_price : selectedService.video_consult_price)
                    : null;
                setShowTypePrice(ShowTypePrice);
            }
        }
    }

    const HandleDateSelect = (date) => {

        setDateSelect(date);
        setTimeLoading(true);

        axios.post(`${ApiBaseUrl}/customer/doctor_appoint_slot`, { d_id: id, date: date, hospital_id: serviceid?.hospital_id, department_id: serviceid?.department_id })
            .then((res) => {
                const { ndatelist } = res.data;
                setTimeList(ndatelist);
                setTimeLoading(false);
                setTimeSelect("");
                setShowTypePrice("");
            })
            .catch((error) => {
                console.error(error);
            })
    }

    const HandleBookAppoint = () => {
        const Userid = secureLocalStorage.getItem("Userid");

        if (!timeSelect) {
            showToast({ title: t("Select time for your appointment!"), id: "error" });
            return;
        }

        const Data = {
            Docid: id,
            subdeparid: serviceid.id,
            HospitalId: selectHospitalId,
            DepartmentId: department_id,
            showtitle: selectBtn1 === 0 ? "In Person Appointment" : "Video Visit Appointment",
            Date: dateSelect,
            datetype: dateType,
            time: timeSelect,
            show_type: selectBtn1 === 0 ? "1" : "2",
            showtypeprice: showTypePrice,
            commission: doctorData?.commission,
        }

        if (!Userid) {
            setIsShow(false);
            setIsLoginShow(true);
            return;
        }

        navigate("/book-appointment", { state: { data: Data } });
    }

    const HandleAddFavorite = (id) => {
        const Userid = secureLocalStorage.getItem("Userid");

        if (Userid) {
            axios.post(`${ApiBaseUrl}/customer/doc_favorite_add_remove`, { id: Userid, d_id: id, department_id: department_id })
                .then((res) => {
                    if (res.data.ResponseCode === 200) {
                        showToast({ title: res.data.message, id: "success" });
                        setIsFav(isFav === 1 ? 2 : 1);
                    }
                })
                .catch((error) => {
                    console.error(error);
                })
        } else {
            setIsLoginShow(true);
        }
    }

    const HandleSelectService = (item) => {
        setServiceId(item);
        setShowType(item.show_type);
        const index = item.show_type === "2" ? 1 : 0;
        setSelectBtn1(index);
    }

    return (
        <div className='width-container docprofile'>
            {loading
                ? <Loading CustomeStyle="fixed left-0 top-0 h-[100vh] w-full flex items-center justify-center bg-white" />
                : <div>

                    <div className="mt-[20px] section-1">

                        <div className="flex items-center justify-between top-section">
                            <Link to="/"
                                className="flex items-center gap-[5px] border-[2px] border-gray-200 rounded-[50px] px-[10px] group py-[4px] hover:bg-black">
                                <IoIosArrowBack className=' group-hover:text-white' />
                                <h1 className='font-[500] group-hover:text-white'> {t("Go Home")}</h1>
                            </Link>
                            <div className="flex items-center gap-[10px] max-_430_:hidden">
                                <Link to={path} className='font-[500] text-gray-700'>{t(pagename)}</Link>
                                <IoIosArrowForward />
                                <h1 className='font-[500] text-gray-400'>{title}</h1>
                            </div>
                            <div className="border-[2px] border-gray-200 rounded-[50px] px-[20px] py-[2px] hidden max-_430_:block">
                                <Link to={path} className='font-[500] text-gray-600'>Back</Link>
                            </div>
                        </div>

                        <div className="mt-[20px] relative">
                            <ImageLoad src={ImgBaseUrl + doctorData?.cover_logo} CustomeStyle={"bg-img w-[100%]"} alt={"Img"} />
                            <button onClick={() => HandleAddFavorite(doctorData.id)} className="absolute right-[15px] top-[15px] bg-[#00000048] p-[8px] rounded-[50px]">
                                {isFav === 1
                                    ? <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12.765 4.70229L12 5.52422L11.235 4.70229C9.12233 2.43257 5.69709 2.43257 3.58447 4.70229C1.47184 6.972 1.47184 10.6519 3.58447 12.9217L10.4699 20.3191C11.315 21.227 12.685 21.227 13.5301 20.3191L20.4155 12.9217C22.5282 10.6519 22.5282 6.972 20.4155 4.70229C18.3029 2.43257 14.8777 2.43257 12.765 4.70229Z" stroke="white" strokeWidth="1.5" strokeLinejoin="round" />
                                    </svg>
                                    : <svg width="24" height="24" viewBox="0 0 24 24" fill="#4038FF" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12.765 4.70229L12 5.52422L11.235 4.70229C9.12233 2.43257 5.69709 2.43257 3.58447 4.70229C1.47184 6.972 1.47184 10.6519 3.58447 12.9217L10.4699 20.3191C11.315 21.227 12.685 21.227 13.5301 20.3191L20.4155 12.9217C22.5282 10.6519 22.5282 6.972 20.4155 4.70229C18.3029 2.43257 14.8777 2.43257 12.765 4.70229Z" stroke="none" strokeWidth="1.5" strokeLinejoin="round" />
                                    </svg>}
                            </button>
                        </div>


                        <div className="max-_770_:mt-0 -mt-[100px] md:flex items-end gap-4">
                            <ImageLoad src={ImgBaseUrl + doctorData?.logo} CustomeStyle={"bg-[#A0E1E1] doctor-img"} alt={"img"} />
                            <div className="flex-1 flex items-center justify-between">
                                <div className='px-[30px] mt-3'>
                                    <div className="doctor-name flex items-center gap-[10px]">
                                        <h1 className='font-bold'>{doctorData?.name}</h1>
                                        {doctorData?.verification_status === "1" && <RiVerifiedBadgeFill className='text-green-500 text-[25px]' />}
                                    </div>
                                    <p className='text-gray-500 font-[500] text-[18px] max-_430_:text-[16px]'>{doctorData?.subtitle}</p>
                                </div>
                            </div>
                        </div>

                        <div className='pt-5 pb-7 border-b'>
                            <div className="flex items-center justify-center gap-6 flex-wrap pt-6 doctor-box padding">

                                <div className="details-box">
                                    <div className="icon-box bg-blue-100 text-blue-600">
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M18 6H16.75V4.5C16.75 3.54 15.96 2.75 15 2.75H9C8.03 2.75 7.25 3.54 7.25 4.5V6H6C4 6 3 7 3 9V9.95996C3 10.89 3.55 11.71 4.41 12.04C5.79 12.59 7.21999 13.0101 8.64999 13.3101C8.75999 13.3301 8.86 13.25 8.92 13.16C9.64 12.08 10.8 11.4301 12 11.4301C13.21 11.4301 14.36 12.08 15.09 13.16C15.15 13.25 15.25 13.3301 15.36 13.3101C16.79 13.0101 18.21 12.59 19.59 12.05C20.45 11.71 21 10.89 21 9.95996V9C21 7 20 6 18 6ZM8.75 6V4.5C8.75 4.36 8.86 4.25 9 4.25H15C15.14 4.25 15.25 4.36 15.25 4.5V6H8.75ZM15.66 14.78C15.55 14.8 15.43 14.8101 15.32 14.8101C14.74 14.8101 14.19 14.51 13.84 13.99C13.4 13.33 12.71 12.9301 12 12.9301C11.3 12.9301 10.61 13.33 10.17 13.99C9.75 14.61 9.04001 14.92 8.35001 14.78C6.83001 14.47 5.32 14.0199 3.86 13.4399C3.55 13.3199 3.26 13.16 3 12.95V18C3 20 4 21 6 21H18C20 21 21 20 21 18V12.96C20.74 13.16 20.45 13.3199 20.14 13.4399C18.68 14.0199 17.17 14.47 15.66 14.78ZM12.002 16C11.451 16 11 15.552 11 15C11 14.448 11.443 14 11.994 14H12.002C12.553 14 13 14.448 13 15C13 15.552 12.553 16 12.002 16Z" fill="currentColor" />
                                        </svg>
                                    </div>
                                    <div className="details">
                                        <h1>{t("Total Experience")}</h1>
                                        <span>{doctorData?.year_of_experience}+ Year</span>
                                    </div>
                                </div>
                                <div className="details-box">
                                    <div className="icon-box bg-yellow-100">
                                        <FaStar className='text-[17px] text-yellow-600' />
                                    </div>
                                    <div className="details">
                                        <h1>{t("Rating")}</h1>
                                        <span>{doctorData?.avg_star}.0 ({doctorData?.tot_review})</span>
                                    </div>
                                </div>
                                <div className="details-box">
                                    <div className="icon-box bg-green-100 text-green-600">
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12 11.25C11.3096 11.25 10.75 10.6904 10.75 10C10.75 9.30964 11.3096 8.75 12 8.75C12.6904 8.75 13.25 9.30964 13.25 10C13.25 10.4142 13.5858 10.75 14 10.75C14.4142 10.75 14.75 10.4142 14.75 10C14.75 8.74122 13.9043 7.67998 12.75 7.35352V6.5C12.75 6.08579 12.4142 5.75 12 5.75C11.5858 5.75 11.25 6.08579 11.25 6.5V7.35352C10.0957 7.67998 9.25 8.74122 9.25 10C9.25 11.5188 10.4812 12.75 12 12.75C12.6904 12.75 13.25 13.3096 13.25 14C13.25 14.6904 12.6904 15.25 12 15.25C11.3096 15.25 10.75 14.6904 10.75 14C10.75 13.5858 10.4142 13.25 10 13.25C9.58579 13.25 9.25 13.5858 9.25 14C9.25 15.2588 10.0957 16.32 11.25 16.6465V17.5C11.25 17.9142 11.5858 18.25 12 18.25C12.4142 18.25 12.75 17.9142 12.75 17.5V16.6465C13.9043 16.32 14.75 15.2588 14.75 14C14.75 12.4812 13.5188 11.25 12 11.25Z" />
                                        </svg>
                                    </div>
                                    <div className="details me-[4px]">
                                        <h1>{t("Consultation Fee")}</h1>
                                        <span>{currency}{doctorData?.min_inp_price} - {currency}{doctorData?.max_inp_price}</span>
                                    </div>
                                </div>
                                <div className="details-box">
                                    <div className="icon-box bg-purple-100 text-purple-600">
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M2 8C2 5.79086 3.79086 4 6 4H12C14.2091 4 16 5.79086 16 8V16C16 18.2091 14.2091 20 12 20H6C3.79086 20 2 18.2091 2 16V8ZM13 9C13 10.1046 12.1046 11 11 11C9.89543 11 9 10.1046 9 9C9 7.89543 9.89543 7 11 7C12.1046 7 13 7.89543 13 9ZM18.5409 16.3103L17.5 15.1999V8.79993L18.5409 7.68961C19.781 6.3669 22 7.24442 22 9.05749V14.9424C22 16.7554 19.781 17.633 18.5409 16.3103Z" fill="currentColor" />
                                        </svg>
                                    </div>
                                    <div className="details">
                                        <h1>{t("Video Visit")}</h1>
                                        <span>{currency}{doctorData?.min_vid_price} - {currency}{doctorData?.max_vid_price}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>


                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 padding mt-6">

                        <div className="lg:col-span-2 space-y-2">

                            <div className="py-[15px] border-b">
                                <div className="flex items-center gap-3 mb-2">
                                    <p className="w-1 h-6 bg-[--button-color] rounded-full"></p>
                                    <h1 className='text-xl font-bold text-gray-900'>{t("Doctor Bio")}</h1>
                                </div>
                                <p className='text-gray-500'>{doctorData?.description}</p>
                            </div>

                            {reviews.length >= 1 && <div className="py-[15px] border-b">
                                <div className="flex items-center gap-3 mb-2">
                                    <p className="w-1 h-6 bg-[--button-color] rounded-full"></p>
                                    <h1 className='text-xl font-bold text-gray-900'>{t("Reviews")}</h1>
                                </div>
                                <div className="w-full lg:h-[400px] overflow-hidden scroll-container">
                                    {reviews.map((item, index) => {
                                        return <div key={index}
                                            className="border-[1px] border-gray-300 py-[10px] px-[20px] rounded-[10px] mb-[8px] mt-[10px]">
                                            <div className="flex items-center justify-between gap-[10px]">
                                                <div className="flex items-center gap-[10px]">
                                                    <div className="min-w-[50px] min-h-[50px] bg-indigo-100 text-indigo-600 rounded-[50px] flex items-center justify-center">
                                                        <h1 className='font-[500] text-[18px]'>{item.cus_name.split("")[0]}</h1>
                                                    </div>
                                                    <div className="leading-[20px]">
                                                        <h1 className='font-[500]'>{item.cus_name}</h1>
                                                        <p className='font-[500] max-_430_:text-[14px]'>{item.hospital_name}</p>
                                                        <span className='text-gray-500'>{item.date}</span>
                                                    </div>
                                                </div>
                                                <div
                                                    className="text-[#4038FF] flex items-center gap-[5px] border-[2px] border-[#4038FF] px-[10px] rounded-[5px]">
                                                    <FaStar className='text-[#4038FF]' />
                                                    <h1 className='font-[500]'>{item.star_no}</h1>
                                                </div>
                                            </div>
                                            <p className='text-gray-500 mt-[5px]'>{item.review}</p>
                                        </div>
                                    })}
                                </div>
                            </div>}

                            {faqList.length >= 1 && <div className="py-[15px] border-b">
                                <div className="flex items-center gap-3 mb-2">
                                    <p className="w-1 h-6 bg-[--button-color] rounded-full"></p>
                                    <h1 className='text-xl font-bold text-gray-900'>{t("FAQs")}</h1>
                                </div>
                                <div className="">
                                    {faqList.map((item, index) => {
                                        return (
                                            <div key={index} className="mb-[8px]">
                                                <Accordion style={{
                                                    border: '1px solid #8080803b', borderRadius: "20px", padding: "10px 0"
                                                }} expanded={expandedIndex === index} onChange={() => handleChange(index)}>
                                                    <AccordionSummary
                                                        expandIcon={<ExpandMoreIcon />}
                                                        aria-controls={`panel${index}-content`}
                                                        id={`panel${index}-header`}
                                                    >
                                                        <Typography className='max-_430_:text-[14px]' component="span">{item.title}</Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails className='max-_430_:text-[14px]'>{item.description}</AccordionDetails>
                                                </Accordion>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>}

                            {doctorData?.cancel_policy && <div className="py-[15px]">
                                <div className="bg-red-50 dark:bg-red-900/10 rounded-xl p-4 border border-red-100 dark:border-red-900/30 flex gap-3">
                                    <svg width="20" height="20" className='min-w-[20px] text-red-500' viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 22.75C6.072 22.75 1.25 17.928 1.25 12C1.25 6.072 6.072 1.25 12 1.25C17.928 1.25 22.75 6.072 22.75 12C22.75 17.928 17.928 22.75 12 22.75ZM12 2.75C6.899 2.75 2.75 6.899 2.75 12C2.75 17.101 6.899 21.25 12 21.25C17.101 21.25 21.25 17.101 21.25 12C21.25 6.899 17.101 2.75 12 2.75ZM13.02 15.5C13.02 14.948 12.573 14.5 12.02 14.5H12.01C11.458 14.5 11.0149 14.948 11.0149 15.5C11.0149 16.052 11.468 16.5 12.02 16.5C12.572 16.5 13.02 16.052 13.02 15.5ZM12.75 12.071V7.5C12.75 7.086 12.414 6.75 12 6.75C11.586 6.75 11.25 7.086 11.25 7.5V12.071C11.25 12.485 11.586 12.821 12 12.821C12.414 12.821 12.75 12.485 12.75 12.071Z" fill="currentColor" />
                                    </svg>
                                    <div className="text-[15px]">
                                        <p className="font-bold text-red-800 mb-1">{t("Cancellation Policy")}</p>
                                        <p className="text-red-700 opacity-90 whitespace-pre-line">{doctorData?.cancel_policy}</p>
                                    </div>
                                </div>
                            </div>}

                        </div>

                        <div className="space-y-2">

                            <div className='py-[15px] border-b'>
                                <div className="flex items-center justify-between mb-2">
                                    <div className="flex items-center gap-3">
                                        <p className="w-1 h-6 bg-[--button-color] rounded-full"></p>
                                        <h1 className='text-xl font-bold text-gray-900'>{t("Awards")}</h1>
                                    </div>
                                    {awards.length > 6 && <button className='text-[--button-color] text-sm font-semibold hover:underline'>{t("View All")}</button>}
                                </div>
                                <div className="grid grid-cols-2 gap-4">
                                    {awards.map((item, index) => {
                                        return <div key={index} className="shadow rounded-[15px] overflow-hidden p-3 hover:shadow-md cursor-pointer">
                                            <ImageLoad src={ImgBaseUrl + item.image} CustomeStyle={"w-[100px] h-[100px] mx-auto object-cover"} alt={"img"} />
                                            <h1 className='mt-2 font-medium text-[13px] line-clamp-2 text-center'>{item.title}</h1>
                                        </div>
                                    })}
                                </div>
                            </div>

                            <div className="py-[15px]">
                                <div className="flex items-center gap-3 mb-2">
                                    <p className="w-1 h-6 bg-[--button-color] rounded-full"></p>
                                    <h1 className='text-xl font-bold text-gray-900'>{t("Clinic Photos")}</h1>
                                </div>
                                <div className="grid grid-cols-2 gap-4">
                                    {photos.map((item, index) => {
                                        if (index < 4) {
                                            return <div key={index} className="h-[150px] cursor-pointer rounded-[10px] overflow-hidden relative">
                                                <div onClick={() => { setphotosIndex(index); setShowLightBox(true) }} className="w-full h-full">
                                                    <ImageLoad src={item.src} CustomeStyle={"w-full h-full object-cover"} alt={"logo"} />
                                                </div>
                                                {(photos.length > 4 && index === 3) && <div onClick={() => { setphotosIndex(0); setShowLightBox(true) }} className="w-full h-full absolute top-0 z-[20] bg-black/50 flex items-center justify-center">
                                                    <span className='text-white font-bold'>+{photos.length - 4} More</span>
                                                </div>}
                                            </div>
                                        }
                                    })}
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="fixed left-1/2 bottom-2 -translate-x-1/2">
                        <button onClick={() => setIsShow(true)} className="px-6 py-2 rounded-full bg-[--button-color] text-white font-medium shadow-md transition shadow-indigo-500/20">
                            {t("Book Appointment")}
                        </button>
                    </div>

                </div>}

            {isShow && <div onClick={() => setIsShow(false)} className='flex bg-[#00000069] h-full justify-center w-full fixed items-end left-0 top-0 z-[999]'>
                <div onClick={(e) => e.stopPropagation()} className="book-box">
                    <div className="px-[20px] py-[10px]">
                        <div className="bg-gray-100 py-[5px] px-[10px] rounded-[10px]">
                            <h1 className='font-[500] text-[20px] max-_430_:text-[18px]'>{t("Service")}</h1>

                            <div className="slider-container mt-[20px]">
                                <Slider {...ServiceSetting}>
                                    {service.map((item, index) => {
                                        return <div onClick={() => HandleSelectService(item)} key={index} className={`${serviceid.id === item.id && "border-[#4038FF]"} border-[1px] service_box`}>
                                            <ImageLoad src={ImgBaseUrl + item.image} CustomeStyle={"w-[30px] h-[30px] min-w-[30px] object-cover rounded-[5px]"} alt={"logo"} />
                                            <h1 className='font-[500] whitespace-nowrap overflow-hidden overflow-ellipsis max-_430_:text-[14px]'>{item.sub_title}</h1>
                                        </div>
                                    })}
                                </Slider>
                            </div>
                        </div>
                        <div className="bg-gray-100 py-[5px] px-[10px] rounded-[10px] mt-[10px] availability">
                            <h1 className='font-[500] text-[20px] max-_430_:text-[18px] mb-[5px]'>{t("Availability")}</h1>
                            <div className="d-flex scroll-container">
                                <div className={`bg-white Select-btn p-[5px] rounded-[50px] flex gap-[20px] ${showType !== "3" && "max-_430_:w-[100%]"}`}>
                                    {(showType === "1" || showType === "3") && <button onClick={() => setSelectBtn1(0)} className={`${selectBtn1 === 0 && "active2"} max-_430_:text-[15px] whitespace-nowrap w-[100%] justify-center`}>
                                        <svg className='duration-[0.3s]' width="24" height="24" viewBox="0 0 24 24" fill={selectBtn1 === 0 ? "#4038FF" : "#28303F"} xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M18 2H6C3.79086 2 2 3.79086 2 6V18C2 19.8642 3.27532 21.4306 5.00111 21.8743C5.32039 21.9563 5.6551 22 6 22H18C18.3449 22 18.6796 21.9563 18.9989 21.8743C20.7247 21.4306 22 19.8642 22 18V6C22 3.79086 20.2091 2 18 2ZM15 9C15 7.34315 13.6569 6 12 6C10.3431 6 9 7.34315 9 9C9 10.6569 10.3431 12 12 12C13.6569 12 15 10.6569 15 9ZM7.15257 17.0155C7.70085 15.2824 9.66322 14 12 14C14.3368 14 16.2991 15.2824 16.8474 17.0155C17.014 17.5421 16.5523 18 16 18H8C7.44772 18 6.98599 17.5421 7.15257 17.0155Z" />
                                        </svg>
                                        {t("In Person")}
                                    </button>}
                                    {(showType === "2" || showType === "3") && <button onClick={() => setSelectBtn1(1)} className={`${selectBtn1 === 1 && "active2"} max-_430_:text-[15px] whitespace-nowrap w-[100%] justify-center`}>
                                        <svg className='duration-[0.3s]' width="24" height="24" viewBox="0 0 24 24" fill={selectBtn1 === 1 ? "#4038FF" : "#28303F"} xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M2 8C2 5.79086 3.79086 4 6 4H12C14.2091 4 16 5.79086 16 8V16C16 18.2091 14.2091 20 12 20H6C3.79086 20 2 18.2091 2 16V8ZM13 9C13 10.1046 12.1046 11 11 11C9.89543 11 9 10.1046 9 9C9 7.89543 9.89543 7 11 7C12.1046 7 13 7.89543 13 9ZM18.5409 16.3103L17.5 15.1999V8.79993L18.5409 7.68961C19.781 6.3669 22 7.24442 22 9.05749V14.9424C22 16.7554 19.781 17.633 18.5409 16.3103Z" />
                                        </svg>
                                        {t("Video Visit")}
                                    </button>}
                                </div>
                            </div>
                            <div className="date-section mt-[10px]">
                                <Slider {...settingsday}>
                                    {dateList?.map((item, index) => {
                                        return <div onClick={() => HandleDateSelect(item.date)} key={index} className={`${dateSelect === item.date && "active"} date-box`}>
                                            <h1 className='font-[500] text-[16px] max-_430_:text-[14px] whitespace-nowrap'>{item.date}</h1>
                                            <span className='font-[500] text-[14px]'>{item.week_day}</span>
                                        </div>
                                    })}
                                </Slider>
                            </div>
                        </div>
                        {!timeLoading
                            ? <div className="">
                                {timeLiat?.Morning.length >= 1 && <div className="bg-gray-100 py-[5px] px-[10px] rounded-[10px] mt-[10px]">
                                    <div className="flex items-center gap-[5px] border-b-[2px] border-white pb-[5px]">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M15 2.25C15.4142 2.25 15.75 2.58579 15.75 3V4C15.75 4.41421 15.4142 4.75 15 4.75C14.5858 4.75 14.25 4.41421 14.25 4V3C14.25 2.58579 14.5858 2.25 15 2.25ZM2 14C2 17.866 5.13401 21 9 21H17C19.7614 21 22 18.7614 22 16C22 13.8639 20.6604 12.0406 18.7755 11.3244C18.2238 11.1148 17.6253 11 17 11C16.4547 11 15.9299 11.0873 15.4386 11.2486C14.7393 9.61449 13.4362 8.30031 11.8097 7.58672C10.9497 7.2094 9.99931 7 9 7C5.13401 7 2 10.134 2 14ZM20.48 5.58049C20.7729 5.2876 20.7729 4.81273 20.48 4.51983C20.1871 4.22694 19.7123 4.22694 19.4194 4.51983L18.7123 5.22694C18.4194 5.51983 18.4194 5.99471 18.7123 6.2876C19.0052 6.58049 19.48 6.58049 19.7729 6.2876L20.48 5.58049ZM22.75 10C22.75 10.4142 22.4142 10.75 22 10.75H21C20.5858 10.75 20.25 10.4142 20.25 10C20.25 9.58579 20.5858 9.25 21 9.25H22C22.4142 9.25 22.75 9.58579 22.75 10ZM15 6C17.1463 6 18.8978 7.69043 18.9957 9.81253C18.3653 9.60932 17.6941 9.5 17 9.5C16.7431 9.5 16.4894 9.51498 16.2396 9.54415C15.4568 8.27448 14.3497 7.22698 13.0331 6.5162C13.6139 6.18758 14.285 6 15 6Z" fill="#eab308" />
                                        </svg>
                                        <h1 className='font-[500] text-[20px] max-_430_:text-[18px]'>{t("Morning")}</h1>
                                    </div>
                                    <div className="time-section mt-[10px]">
                                        <div className="slider-container">
                                            <Slider {...settingstime}>
                                                {timeLiat?.Morning.map((item, index) => {
                                                    return <div onClick={() => HandleTimeSelect(item, "Morning")} key={index} className={`${timeSelect === item.t && "select"} ${item.o === 0 && "disabled"} ${item.o === 2 && "deselect"} date-box`}>
                                                        <h1 className='font-[500] text-[16px] max-_430_:text-[14px] whitespace-nowrap'>{item.t.split(" ")[0]}</h1>
                                                        <span className='font-[500] text-[14px]'>{item.t.split(" ")[1]}</span>
                                                    </div>
                                                })}
                                            </Slider>
                                        </div>
                                    </div>
                                </div>}
                                {timeLiat?.Afternoon.length >= 1 && <div className="bg-gray-100 py-[5px] px-[10px] rounded-[10px] mt-[10px]">
                                    <div className="flex items-center gap-[5px] border-b-[2px] border-white pb-[5px]">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="#FF6D00" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M12 1.25C12.4142 1.25 12.75 1.58579 12.75 2V3C12.75 3.41421 12.4142 3.75 12 3.75C11.5858 3.75 11.25 3.41421 11.25 3V2C11.25 1.58579 11.5858 1.25 12 1.25ZM18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12ZM12.75 21C12.75 20.5858 12.4142 20.25 12 20.25C11.5858 20.25 11.25 20.5858 11.25 21V22C11.25 22.4142 11.5858 22.75 12 22.75C12.4142 22.75 12.75 22.4142 12.75 22V21ZM19.6014 4.39849C19.8943 4.69139 19.8943 5.16626 19.6014 5.45915L18.8943 6.16626C18.6014 6.45915 18.1265 6.45915 17.8336 6.16626C17.5407 5.87337 17.5407 5.39849 17.8336 5.1056L18.5407 4.39849C18.8336 4.1056 19.3085 4.1056 19.6014 4.39849ZM6.16632 18.8942C6.45921 18.6013 6.45921 18.1264 6.16632 17.8336C5.87342 17.5407 5.39855 17.5407 5.10566 17.8336L4.39855 18.5407C4.10566 18.8336 4.10566 19.3084 4.39855 19.6013C4.69144 19.8942 5.16632 19.8942 5.45921 19.6013L6.16632 18.8942ZM22.75 12C22.75 12.4142 22.4142 12.75 22 12.75H21C20.5858 12.75 20.25 12.4142 20.25 12C20.25 11.5858 20.5858 11.25 21 11.25H22C22.4142 11.25 22.75 11.5858 22.75 12ZM3 12.75C3.41421 12.75 3.75 12.4142 3.75 12C3.75 11.5858 3.41421 11.25 3 11.25H2C1.58579 11.25 1.25 11.5858 1.25 12C1.25 12.4142 1.58579 12.75 2 12.75H3ZM19.6014 19.6014C19.3085 19.8943 18.8336 19.8943 18.5407 19.6014L17.8336 18.8943C17.5407 18.6014 17.5407 18.1265 17.8336 17.8336C18.1265 17.5407 18.6014 17.5407 18.8943 17.8336L19.6014 18.5407C19.8943 18.8336 19.8943 19.3085 19.6014 19.6014ZM5.10566 6.16632C5.39856 6.45921 5.87343 6.45921 6.16633 6.16632C6.45922 5.87342 6.45922 5.39855 6.16633 5.10566L5.45922 4.39855C5.16633 4.10566 4.69145 4.10566 4.39856 4.39855C4.10566 4.69144 4.10566 5.16632 4.39856 5.45921L5.10566 6.16632Z" fill="" />
                                        </svg>

                                        <h1 className='font-[500] text-[20px] max-_430_:text-[18px]'>{t("Afternoon")}</h1>
                                    </div>
                                    <div className="time-section mt-[10px]">
                                        <div className="slider-container">
                                            <Slider {...settingstime}>
                                                {timeLiat?.Afternoon.map((item, index) => {
                                                    return <div onClick={() => HandleTimeSelect(item, "Afternoon")} key={index} className={`${timeSelect === item.t && "select"} ${item.o === 0 && "disabled"} ${item.o === 2 && "deselect"} date-box`}>
                                                        <h1 className='font-[500] text-[16px] max-_430_:text-[14px] whitespace-nowrap'>{item.t.split(" ")[0]}</h1>
                                                        <span className='font-[500] text-[14px]'>{item.t.split(" ")[1]}</span>
                                                    </div>
                                                })}
                                            </Slider>
                                        </div>
                                    </div>
                                </div>}
                                {timeLiat?.Evening.length >= 1 && <div className="bg-gray-100 py-[5px] px-[10px] rounded-[10px] mt-[10px]">
                                    <div className="flex items-center gap-[5px] border-b-[2px] border-white pb-[5px]">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="#004C98" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M5.67169 14.8685C10.7511 14.8685 14.8687 10.7508 14.8687 5.67144C14.8687 5.0679 14.8106 4.47793 14.6996 3.90684C14.6234 3.51469 14.9857 3.16204 15.3541 3.31639C18.6704 4.70571 21.0001 7.98219 21.0001 11.8028C21.0001 16.8822 16.8824 20.9998 11.803 20.9998C7.98244 20.9998 4.70596 18.6702 3.31664 15.3539C3.16228 14.9854 3.51494 14.6231 3.90708 14.6993C4.47817 14.8103 5.06814 14.8685 5.67169 14.8685Z" />
                                        </svg>

                                        <h1 className='font-[500] text-[20px] max-_430_:text-[18px]'>{t("Evening")}</h1>
                                    </div>
                                    <div className="time-section mt-[10px]">
                                        <div className="slider-container">
                                            <Slider {...settingstime}>
                                                {timeLiat?.Evening.map((item, index) => {
                                                    return <div onClick={() => HandleTimeSelect(item, "Evening")} key={index} className={`${timeSelect === item.t && "select"} ${item.o === 0 && "disabled"} ${item.o === 2 && "deselect"} date-box`}>
                                                        <h1 className='font-[500] text-[16px] max-_430_:text-[14px] whitespace-nowrap'>{item.t.split(" ")[0]}</h1>
                                                        <span className='font-[500] text-[14px]'>{item.t.split(" ")[1]}</span>
                                                    </div>
                                                })}
                                            </Slider>
                                        </div>
                                    </div>
                                </div>}
                            </div>
                            : < Loading CustomeStyle="h-[300px] flex items-center justify-center bg-gray-100 rounded-[10px] mt-[10px]" />}
                    </div>
                    {timeSelect !== "" && (
                        <div className="bg-[#4038FF] rounded-t-[10px]">
                            {hospitalList.map((item, index) => {
                                if (item.id === Number(selectHospitalId)) {
                                    return (
                                        <div key={index} className="p-[10px]">
                                            <div className="flex items-center gap-[5px]">
                                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M15 17V21.25H9V17C9 15.3431 10.3431 14 12 14C13.6569 14 15 15.3431 15 17ZM22 21.25H20V6C20 3.79086 18.2091 2 16 2H8C5.79086 2 4 3.79086 4 6V21.25H2C1.58579 21.25 1.25 21.5858 1.25 22C1.25 22.4142 1.58579 22.75 2 22.75H22C22.4142 22.75 22.75 22.4142 22.75 22C22.75 21.5858 22.4142 21.25 22 21.25ZM12.75 5C12.75 4.58579 12.4142 4.25 12 4.25C11.5858 4.25 11.25 4.58579 11.25 5V7.25H9C8.58579 7.25 8.25 7.58579 8.25 8C8.25 8.41421 8.58579 8.75 9 8.75H11.25V11C11.25 11.4142 11.5858 11.75 12 11.75C12.4142 11.75 12.75 11.4142 12.75 11V8.75H15C15.4142 8.75 15.75 8.41421 15.75 8C15.75 7.58579 15.4142 7.25 15 7.25H12.75V5Z" fill="white" />
                                                </svg>
                                                <h1 className='text-white'>{t("Clinic Details")}</h1>
                                            </div>
                                            <p className='text-white font-[500]'>{item.name}</p>
                                            <span className='text-white font-[500]'>{item.address}</span>
                                        </div>
                                    );
                                }
                            })}
                        </div>
                    )}
                    <div className="rounded-t-[10px] bg-white p-[10px]">
                        <button onClick={HandleBookAppoint} className='book-btn'>{t("Book Appointment")} {showTypePrice && currency + showTypePrice}</button>
                    </div>
                </div>
            </div>}

            <Lightbox
                open={showLightBox}
                close={() => setShowLightBox(false)}
                slides={photos}
                index={photosIndex}
                plugins={[Zoom]}
            />

        </div >
    );
};

export default DocProfile;
/* jshint ignore:end */